export default {
  metadata: {
    version: '1.0.0',
    id: 'header-desktop-1.0.0',
    name: 'JDSHeaderDesktop',
    platform: 'web'
  },
  hierarchy: {
    container: [
      {
        'header-container': [
          {
            'left-container': [
              {
                'prefix-container': [
                  'prefix-jds_button',
                  {
                    'logo-container': ['logo-slot', 'logo-jds-text']
                  },
                  'prefix-slot',
                  'name-jds-text'
                ]
              },
              {
                'links-container': ['link-jds_link']
              }
            ]
          },
          'jds_search_box',
          {
            'right-container': [
              {
                'suffix-container': [
                  'search-jds_action_button',
                  {
                    'icon-links-container': ['icon-links-slot']
                  },
                  'avatar-slot'
                ]
              },
              'suffix-jds_action_button',
              'suffix-slot'
            ]
          }
        ]
      },
      'jds_mega_menu',
      'jds_search_results',
      'tabs-slot'
    ]
  },
  base: {
    container: {
      'min-width': '{h_0}',
      'flex-direction': '{h_1}'
    },
    'prefix-container': {
      'flex-direction': '{h_2}',
      'justify-content': '{h_3}',
      'align-items': '{h_4}',
      gap: '{h_5}'
    },
    'header-container': {
      'min-width': '{h_6}',
      'background-color': '{h_7}',
      'flex-direction': '{h_8}',
      'justify-content': '{h_9}',
      'align-items': '{h_10}',
      'padding-left': '{h_11}',
      'padding-top': '{h_12}',
      'padding-right': '{h_13}',
      'padding-bottom': '{h_14}',
      gap: '{h_15}',
      height: '{h_16}'
    },
    'left-container': {
      'flex-direction': '{h_17}',
      'justify-content': '{h_18}',
      'align-items': '{h_19}',
      gap: '{h_20}'
    },
    'logo-container': {
      'flex-direction': '{h_21}',
      'justify-content': '{h_22}',
      'align-items': '{h_23}',
      gap: '{h_24}'
    },
    'profile-container': {
      hidden: true,
      'flex-direction': '{h_25}',
      'justify-content': '{h_26}',
      'align-items': '{h_27}',
      gap: '{h_28}'
    },
    'links-container': {
      'flex-direction': '{h_29}',
      'justify-content': '{h_30}',
      'align-items': '{h_31}',
      gap: '{h_32}',
      'padding-left': '{h_33}',
      flex: 1,
      hidden: false
    },
    'right-container': {
      'flex-direction': '{h_34}',
      'justify-content': '{h_35}',
      'align-items': '{h_36}',
      gap: '{h_37}'
    },
    'suffix-container': {
      'flex-direction': '{h_38}',
      'justify-content': '{h_39}',
      'align-items': '{h_40}',
      gap: '{h_41}',
      width: '{h_42}'
    },
    'icon-links-container': {
      'flex-direction': '{h_43}',
      'justify-content': '{h_44}',
      'align-items': '{h_45}',
      gap: '{h_46}',
      hidden: false
    },
    'prefix-jds_button': {
      size: 'medium',
      fullWidth: false
    },
    'search-jds_action_button': {
      hidden: true,
      icon: 'ic_search',
      size: 'medium'
    },
    'icon-links-jds_link': {
      size: 'medium'
    },
    'suffix-jds_action_button': {
      hidden: true,
      icon: 'ic_close',
      size: 'medium'
    },
    jds_search_box: {
      prefix: 'ic_search',
      kind: 'header',
      'max-width': '312',
      width: '{h_47}'
    },
    'link-jds_link': {
      kind: 'header'
    },
    jds_search_results: {
      open: false,
      hidden: false,
      _maxWidth: 784
    },
    'logo-jds-text': {
      'font-family': '{text_91}',
      color: '{text_18}',
      'font-size': '{text_90}',
      'line-height': '{text_92}',
      'letter-spacing': '{text_93}',
      'font-weight': '{text_94}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'name-jds-text': {
      'font-family': '{text_132}',
      color: '{text_18}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'link-jds-text': {
      'font-family': '{text_137}',
      color: '{text_18}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    }
  },
  variant: {
    _platform: {
      mobile: {
        'links-container': {
          hidden: true
        },
        'profile-container': {
          hidden: false
        },
        'suffix-jds_action_button': {
          hidden: true
        },
        jds_mega_menu: {
          hidden: true
        },
        'header-container': {
          'padding-left': '{h_49}',
          'padding-right': '{h_50}',
          gap: '{h_51}',
          height: '{h_48}'
        },
        'left-container': {
          gap: '{h_52}'
        },
        'right-container': {
          gap: '{h_53}'
        },
        'suffix-container': {
          gap: '{h_54}'
        }
      }
    },
    _variant: {
      active_search: {
        'header-container': {
          'justify-content': '{h_56}'
        },
        'profile-container': {
          hidden: true
        },
        'links-container': {
          hidden: true
        },
        'avatar-slot': {
          hidden: true
        },
        'prefix-slot': {
          hidden: true
        },
        'suffix-jds_action_button': {
          hidden: false
        },
        'icon-links-container': {
          hidden: true
        },
        jds_search_box: {
          'max-width': '784',
          width: '{h_57}'
        },
        'suffix-slot': {
          hidden: true
        },
        jds_search_results: {
          open: true
        },
        'prefix-jds_button': {
          hidden: true
        },
        'name-jds-text': {
          hidden: true
        },
        'logo-jds-text': {
          hidden: true
        }
      }
    },
    search: {
      false: {
        jds_search_box: {
          hidden: true
        },
        'search-jds_action_button': {
          hidden: true
        }
      }
    },
    fullWidth: {
      false: {
        container: {
          width: '{h_58}'
        }
      }
    },
    _IsLinksEmpty: {
      true: {
        'icon-links-container': {
          hidden: true
        }
      }
    },
    _hasSearchResults: {
      false: {
        jds_search_results: {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      true: {
        false: {
          jds_search_box: {
            hidden: true
          },
          'search-jds_action_button': {
            hidden: false
          }
        }
      }
    },
    {
      mobile: {
        active_search: {
          'suffix-jds_action_button': {
            hidden: false
          }
        }
      },
      desktop: {
        default: {
          'left-container': {
            width: '{h_55}'
          }
        }
      }
    },
    {
      mobile: {
        false: {
          'header-container': {
            'justify-content': '{h_59}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['search', 'expandedSearch'],
    ['_platform', '_variant'],
    ['_platform', 'search']
  ],
  api: {
    config: {
      _variant: {
        values: ['default', 'active_search']
      },
      _platform: {
        values: ['desktop', 'mobile']
      },
      search: {
        values: [true, false]
      },
      expandedSearch: {
        values: [true, false]
      },
      searchActive: {
        values: [false, true]
      },
      fullWidth: {
        values: [true, false]
      },
      _IsLinksEmpty: {
        values: [false, true]
      },
      _hasSearchResults: {
        values: [true, false]
      }
    },
    data: {
      'prefix-jds_button': {
        icon: {
          name: 'prefix',
          type: 'icon'
        }
      },
      'links-container': {
        value: {
          type: 'list',
          name: 'links',
          object: {
            newTab: 'boolean',
            href: 'string',
            title: 'string',
            routerLinkProps: 'object',
            onClick: 'event',
            subLinks: 'list',
            active: 'boolean'
          }
        }
      },
      'link-jds_link': {
        title: {
          type: 'string',
          name: 'links.title'
        },
        href: {
          type: 'string',
          name: 'links.href'
        },
        newTab: {
          type: 'string',
          name: 'links.newTab',
          platform: 'web'
        },
        routerLinkProps: {
          type: 'string',
          name: 'links.routerLinkProps',
          platform: 'angular'
        },
        onClick: {
          type: 'string',
          name: 'links.onClick'
        },
        _active: {
          type: 'string',
          name: 'links.active'
        }
      },
      jds_search_box: {
        label: {
          type: 'string',
          name: 'searchLabel'
        },
        suffix: {
          type: 'icon',
          name: 'searchSuffix'
        },
        value: {
          type: 'string',
          name: 'query'
        },
        showBack: {
          type: 'boolean',
          name: 'searchShowBack'
        }
      },
      'header-container': {
        elementRef: {
          type: 'ref',
          name: 'elementRef'
        }
      },
      container: {
        value: {
          type: 'object',
          name: 'megaMenuProps',
          object: {
            subLinks: 'list',
            offsetX: 'size',
            offsetY: 'size',
            width: 'size',
            open: 'boolean'
          }
        }
      },
      jds_search_results: {
        offsetX: {
          type: 'size',
          name: 'megaMenuProps.offsetX'
        },
        offsetY: {
          type: 'size',
          name: 'megaMenuProps.offsetY'
        },
        _maxWidth: {
          type: 'size',
          name: 'megaMenuProps.width'
        },
        results: {
          type: 'list',
          name: 'searchResults'
        },
        header: {
          type: 'string',
          name: 'searchResultHeader'
        },
        query: {
          type: 'string',
          name: 'query'
        },
        headerAction: {
          type: 'string',
          name: 'searchResultHeaderAction'
        }
      },
      jds_mega_menu: {
        items: {
          type: 'object',
          name: 'megaMenuProps.subLinks'
        },
        offsetX: {
          type: 'size',
          name: 'megaMenuProps.offsetX'
        },
        offsetY: {
          type: 'size',
          name: 'megaMenuProps.offsetY'
        },
        width: {
          type: 'size',
          name: 'megaMenuProps.width'
        },
        open: {
          type: 'boolean',
          name: 'megaMenuProps.open'
        }
      },
      'logo-jds-text': {
        value: {
          type: 'string',
          name: 'brandLabel'
        }
      },
      'name-jds-text': {
        value: {
          type: 'string',
          name: 'pageTitle'
        }
      }
    },
    children: {
      'avatar-slot': {
        name: 'avatar',
        accepts: ['jds_avatar', 'jds_link'],
        max: 1
      },
      'prefix-slot': {
        name: 'pageTitlePrefix',
        accepts: ['jds_avatar', 'jds_icon', 'jds_image'],
        max: 1
      },
      'tabs-slot': {
        name: 'tabs',
        accepts: ['jds_tab'],
        max: 1
      },
      'suffix-slot': {
        name: 'suffix',
        accepts: ['jds_text', 'jds_button', 'jds_link'],
        max: 1
      },
      'logo-slot': {
        name: 'logo',
        accepts: ['jds_icon', 'jds_image', 'jds_link'],
        max: 1
      },
      'icon-links-slot': {
        name: 'iconLinks',
        accepts: ['jds_link']
      }
    },
    events: {
      container: {
        '_searchActive.onSearchActiveChange': 'onSearchActiveChange'
      },
      'logo-container': {
        onClick: 'logoOnClick'
      },
      'avatar-slot': {
        onClick: 'avatarOnClick'
      },
      'prefix-jds_button': {
        onClick: 'prefixOnClick'
      },
      'suffix-jds_action_button': {
        onClick: 'suffixOnClick'
      },
      'link-jds_link': {
        onHover: 'onHover'
      },
      jds_mega_menu: {
        onHoverEnd: 'onMenuHoverEnd'
      },
      jds_search_box: {
        onBlur: 'onSearchBlur',
        onFocus: 'onSearchFocus',
        onChange: 'onSearchChange',
        onSuffixClick: 'onSearchBoxSuffixClick',
        onKeydown: 'onSearchKeydown'
      },
      'search-jds_action_button': {
        onClick: 'onSearchIconClick'
      },
      jds_search_results: {
        onHeaderActionClick: 'onSearchResultHeaderActionClick',
        onClick: 'onSearchResultClick'
      }
    },
    a11y: {
      container: {
        name: 'megaMenuProps',
        repeating: {
          ariaLabel: 'menuItemAriaLabel',
          ariaDescribedby: {
            name: 'menuItemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'links-container': {
        name: 'links',
        repeating: {
          ariaLabel: 'linkAriaLabel',
          ariaDescribedby: {
            name: 'linkAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'link-jds_link': {
        properties: {
          ariaLabel: 'links.linkAriaLabel',
          ariaDescribedby: 'links.linkAriaDescribedby'
        }
      },
      'prefix-jds_button': {
        properties: {
          ariaLabel: 'prefixAriaLabel',
          ariaDescribedby: {
            name: 'prefixAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'suffix-jds_action_button': {
        properties: {
          ariaLabel: 'suffixAriaLabel',
          ariaDescribedby: {
            name: 'suffixAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_search_box: {
        properties: {
          prefixAriaLabel: 'searchBoxPrefixAriaLabel',
          suffixAriaLabel: 'searchBoxSuffixAriaLabel',
          ariaLabel: 'searchAriaLabel'
        }
      },
      'search-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'searchButtonAriaLabel',
            prop: 'dynamicButtonText'
          },
          ariaDescribedby: {
            name: 'searchButtonAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
